export default {
  title: {
    en: 'An error occurred while PayPal authorization.',
  },
  text: {
    en: 'Please, wait for a minute and try again or try to pay with your credit card. If problem appears again, contact our customer support support@scentbird.com',
  },
  button: {
    en: 'Got it',
  },
}
